/**
 * Configuração de AI por entidade (projeto) — o contexto é dado pelo header `Entity`.
 */

export enum EnumAICurrency {
    EUR = 1,
    USD = 2
}

/** Código ISO da moeda, usado na formatação dos valores. */
export const AICurrencyCode: { [key: number]: string } = {
    [EnumAICurrency.EUR]: 'EUR',
    [EnumAICurrency.USD]: 'USD'
};

export interface IAIConfigurationModel {

    Id?: string;
    IdEntity?: string;

    /** AI ativa para o projeto. */
    IsActive: boolean;

    /** A chave nunca é devolvida pelo backend — apenas os últimos caracteres para referência. */
    ApiKeyMask?: string;

    /** True se a entidade já tem chave guardada. */
    HasApiKey?: boolean;

    IdCurrency: EnumAICurrency;

    /** Limite de custo por mês, na moeda de `IdCurrency`. 0 = sem limite. */
    CostLimitMonth: number;

    /** Consumo do mês corrente, preenchido pelo backend (só leitura). */
    CurrentMonthCost?: number;
    CurrentMonthRequests?: number;

    UpdateDate?: string;
    UpdateUser?: string;
}

export interface IAIConfigurationSubmitModel {

    IsActive: boolean;

    /** Só é enviada quando o utilizador escreve uma nova chave; null/'' mantém a atual. */
    ApiKey: string;

    IdCurrency: EnumAICurrency;

    CostLimitMonth: number;
}

export interface IAIConsumptionMonthModel {

    Year: number;

    /** 1-12 */
    Month: number;

    Requests: number;

    InputTokens: number;
    OutputTokens: number;

    /** Custo do mês na moeda de `IdCurrency`. */
    Cost: number;

    IdCurrency: EnumAICurrency;

    /** Limite configurado no mês (histórico do limite em vigor). */
    CostLimitMonth?: number;

    /** True se o limite foi atingido nesse mês e os pedidos passaram a ser recusados. */
    LimitReached?: boolean;
}

/** Corpo do POST Indicators/AI/Search. */
export interface IAISearchSubmitModel {

    /** Pergunta em linguagem natural. Maximo 500 caracteres do lado do backend. */
    Question: string;

    /** Intervalo dos dados a considerar. Vazio assume o ultimo ano. */
    StartDate?: string;
    EndDate?: string;
}

/** Resposta do painel "Pesquisa AI". O consumo ja foi registado quando isto chega. */
export interface IAISearchResultModel {

    Question: string;

    /** Resposta em texto, com markdown simples. */
    Answer: string;

    Model: string;

    InputTokens: number;
    OutputTokens: number;

    Date: string;
}
